import { ProductManagementModel } from './product-management.model';

export class ProductManagementFanModel {

    fanMap: Map<string, Array<ProductManagementModel>>;

    constructor() {
        this.fanMap = undefined;
    }
}
